import { Pricing } from 'my-purchases/components/Pricing/Pricing'
import { CONTENT_PLACEHOLDER } from 'my-purchases/constants/constants'
import { cx } from 'utils/cx'

import styles from './SummaryLine.module.scss'

interface SummaryLineProps {
	readonly additionalPrices?: string[]
	readonly className?: string
	readonly 'data-testid'?: string
	readonly label: string | JSX.Element
	readonly showAdditionalPrices?: boolean
	readonly price: string
}
export function SummaryLine({
	className,
	'data-testid': dataTestId,
	label,
	additionalPrices,
	price,
}: SummaryLineProps) {
	if (!price || price === CONTENT_PLACEHOLDER) {
		return null
	}

	return (
		<div className={cx(styles.line, className)}>
			<span>{label}</span>
			<Pricing
				data-testid={dataTestId}
				price={price}
				additionalPrices={additionalPrices}
				className={styles.endLine}
			/>
		</div>
	)
}
